
document.addEventListener('DOMContentLoaded', () => {
    // Get all radio buttons and the dropdown
  const radioButtons = document.querySelectorAll('input[name="Pack Size Selection"]');
  const dropdown = document.querySelector('.sticky-add-to-cart .variant-dropdown');
  
  // Add event listener to each radio button
  radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        console.log('radio button clicked');
          if (radio.checked) {
              // Find the option with the matching data-name
              const relatedOption = Array.from(dropdown.options).find(
                  option => option.dataset.name === radio.value
              );
  
              // Select the related option if it exists
              if (relatedOption) {
                  dropdown.value = relatedOption.value; // Set the dropdown's selected value
                  console.log(`Selected Option: ${relatedOption.textContent.trim()}`);
              } else {
                  console.log(`No matching option found for radio value: ${radio.value}`);
              }
          }
      });
  });
    
  
// Initialize Swiper for Announcement Bar
const announcementBarSwiper = new Swiper('.announcement-bar-swiper .swiper-container', {
    slidesPerView: '1',
    spaceBetween: 30,
    loop: true,
    freeMode: true,
    speed: 6000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 40,
      },
      1400: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
    loopedSlides: document.querySelectorAll('.announcement-bar .swiper-slide').length,
  });


        // Initialize Swiper for shop_by_concern
        const shop_by_concern = new Swiper('.shop_by_concern .swiper-container', {
          slidesPerView: 4,
          spaceBetween: 15,
          loop: false,
          scrollbar: {
          el: ".shop_by_concern .swiper-scrollbar",
          },
          pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
          breakpoints: {
            340: {
              slidesPerView: 1,
            },
            750: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
              spaceBetweenSlides: 20
            }
          } 
        });

  const pdp_beautywise = new Swiper('.pdp-beautywise-banner .swiper-container', {
          slidesPerView: 1.5,
          spaceBetween: 10,
          loop: false,
        });

  const pdp_benefits = new Swiper('.pdp-benefits-banner .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          pagination: {
              el: '.swiper-pagination',
              clickable: true,
          },
        });

   const pdp_healthy = new Swiper('.pdp-healthy .swiper-container', {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
         breakpoints: {
            30: {
              slidesPerView: 1,
            },
            750: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetweenSlides: 20
            }
          } 
        });

   // Initialize Swiper for success_story
        const success_story = new Swiper('.home-success-story .swiper-container', {
          slidesPerView: 4,
          spaceBetween: 15,
          loop: false,
          breakpoints: {
            30: {
              slidesPerView: 1,
            },
            750: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 4,
              spaceBetweenSlides: 20
            }
          } 
        });



        // Initialize Swiper for Announcement Bar
   const LogoList = new Swiper('.logo-list-custom .swiper-container', {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: true,
          freeMode: true,
          speed: 3000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 0,
            }
          },
          loopedSlides: document.querySelectorAll('.logo-list-custom .swiper-slide').length,
        });

  const LogoListnew = new Swiper('.pdp-marquee .swiper-container', {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: true,
          freeMode: true,
          speed: 3000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 0,
            }
          },
          loopedSlides: document.querySelectorAll('.pdp-marquee .swiper-slide').length,
        });
   


    // Initialize Swiper for Announcement Bar
    const insideSwiper = new Swiper('.keep_moving_onHover .swiper-container', {
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      freeMode: true,
      speed: 3000,
      allowTouchMove:false,
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
      loopedSlides: document.querySelectorAll('.keep_moving_onHover .swiper-slide').length,
    });

    const image_with_text = new Swiper('.image-with-text__text-item.product_page .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    const comp_slider = new Swiper('.right_side_slider_div_wrapper .swiper-container', {
      slidesPerView: 2.5,
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        767: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        1080: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
         1440: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        }
      },
    });

  const pdp_review_slider = new Swiper('.pdp-customer-main .customer-slider.swiper-container', {
      slidesPerView: 2,
      spaceBetween: 15,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next-n',
        prevEl: '.swiper-button-prev-n',
      },
      breakpoints: {
         320: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
         560: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: '2.5',
          spaceBetween: 20,
        }
      },
    });

  const pdp_text_slider = new Swiper('.pdp-skin-wrapper .content_slider.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next-skin',
        prevEl: '.swiper-button-prev-skin',
      },
      breakpoints: {
        1024: {
          slidesPerView: '1',
          spaceBetween: 0,
        }
      },
    });


      if (window.innerWidth < 767){
        // Initialize Swiper for mobile view last swiper on home page 
        const anotherOneLogoList = new Swiper('.logo-list-custom-last.anotherOne .swiper-container', {
          slidesPerView: 3,
          spaceBetween: 0,
          loop: true,
          freeMode: true,
          speed: 3000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 6,
              spaceBetween: 0,
            }
          },
          loopedSlides: document.querySelectorAll('.logo-list-custom-last.anotherOne .swiper-slide').length,
        });


        const viceTmzMetro = new Swiper('.vice-tmz-mtero-section .swiper-container', {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          pagination: {
            el: '.vice-tmz-mtero-section .swiper-pagination',
            clickable: true,
          },
        });
      }

// if (window.innerWidth < 767){
    const pdp_review_slider_home = new Swiper('.homepage-review .review-wrapper.swiper-container', {
      slidesPerView: 5.5,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next-review',
        prevEl: '.swiper-button-prev-review',
      },
      pagination: {
        el: '.homepage-review .review-wrapper .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        300: {
          slidesPerView: '1.5',
        },
        800: {
          slidesPerView: '2.7',
        },
        1200: {
          slidesPerView: '3.3',
        },
        1440: {
          slidesPerView: '3.9',
        },
        1520: {
          slidesPerView: '4.3',
        },
        1600: {
          slidesPerView: '4.7',
        }
      },
    });
//}


   
})
